export type OrgField = {
  id: string
  title: string
  placeholder: string
  type: string
}

export type Organization = {
  role: string
  status: string
  id: string
  name: string
  headMessage?: string
  bodyMessage: string
  fields: OrgField[]
  organizationName?: string
}

export type Role = {
  roleId: number
  name?: string | null
}

export enum RoleName {
  SiteAdmin = 1,
  Admin = 8,
  Recruiter = 3,
  SimulationUser = 5,
  TeamMember = 4,
}

export type User = {
  id: number
  firstName: string
  lastName: string
  email: string
  organizationId: number
  role: number
  userHash: string
  token: string
  imageUrl: string
  createdOn: string
  userName: string
  status: number
  expire_status: number
  roleName: string
  organizationName: string
  roles: Role[]
}

export type AuthState = {
  organization: Organization
  role: Role
  user: User
  isAuthenticated: boolean
  completedTutorial: boolean
  testTitle: string
}
